import { render, staticRenderFns } from "./OtherBusDialog.vue?vue&type=template&id=ce835cc2&scoped=true"
import script from "./OtherBusDialog.vue?vue&type=script&lang=js"
export * from "./OtherBusDialog.vue?vue&type=script&lang=js"
import style0 from "./OtherBusDialog.vue?vue&type=style&index=0&id=ce835cc2&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce835cc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce835cc2')) {
      api.createRecord('ce835cc2', component.options)
    } else {
      api.reload('ce835cc2', component.options)
    }
    module.hot.accept("./OtherBusDialog.vue?vue&type=template&id=ce835cc2&scoped=true", function () {
      api.rerender('ce835cc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/components/OtherBusDialog.vue"
export default component.exports